module.exports = __webpack_public_path__ + "res/24-img_info_b.e1dc8f9fea5d6e8854fb86754a7753d0.png";